<template>
  <div>
    <div class="study_info">
      <div class="study_info_log">
        <div class="title_box">
          <div class="title">学习历史记录</div>
          <div style="font-size: 14px" class="title">
            <span>学习总时长</span> &nbsp;
            <span class="study_time_all">{{ study_time }}</span>
          </div>
        </div>
        <el-scrollbar style="height: 100%" class="left-box" ref="scrollbar">
          <div class="date-picker">
            <el-date-picker
              style="width: 115px"
              :clearable="false"
              v-model="showDate"
              type="month"
              placeholder="选择日期"
              @change="changeDate"
            >
            </el-date-picker>
          </div>
          <div v-for="(v, i) in nowDateList" :key="i">
            <div style="font-weight: bold; color: #23262f; font-size: 16px">
              {{ v.title }}
            </div>
            <el-timeline>
              <el-timeline-item
                v-for="(activity, index) in v.list"
                :key="index"
                color="#0bbd87"
              >
                <div>
                  <div class="study_time">
                    {{ activity.date }}
                  </div>
                  <div class="study_img">
                    <img
                      :src="activity.course_cover_url"
                      alt=""
                      style="cursor: pointer"
                      @click="getVideoUrl(activity.course_id)"
                    />
                  </div>
                  <div class="study_title">
                    {{ activity.title }}
                  </div>
                  <div class="study_time_long">
                    学习时长&nbsp;&nbsp;{{ activity.study_time_long }}
                  </div>
                </div>
              </el-timeline-item>
            </el-timeline>
          </div>
          <div
            style="text-align: center; color: #dadada; font-size: 14px;height:110px"
            v-if="showTextFlag"
          >
            没有更多数据了
          </div>
        </el-scrollbar>
      </div>
      <div class="study_info_echeart">
        <div class="study_info_host" v-loading="loadingBin">
          <div class="title">板块热度占比</div>
          <div id="bin" class="echarts_cotent"></div>
        </div>
        <div class="study_info_top" v-loading="loadingZhu">
          <div class="title">课程TOP榜</div>
          <div id="zhu" class="echarts_cotent_zhu"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  data() {
    return {
      study_time: "00:00:00",
      user_id: "",
      loadingBin: false,
      loadingZhu: false,
      showTextFlag: false,
      showDate:"",
      activities: [],
      nowDate: "",
      num: 0,
      page: 1,
      page_size: 10,
      videoUrl: "",
      totalPage: 1, //总页数
      nowDateList: [], //[{list:[{}],title:''},{list:[{}],title:'']
    };
  },
  mounted() {
    this.user_id = this.$route.query.id;
    this.nowDate = moment().format("YYYY-MM");
    this.showDate = moment().format("YYYY-MM");
    this.drawChart();
    this.drawChartZhu();
    this.getUserLog();
    this.scrollbarDown();
  },
  methods: {
    async drawChart() {
      this.loadingBin = true;
      const [err, res] = await this.$http.post("study/hotRate", {
        user_id: this.user_id,
      });
      if (err) {
        this.loadingBin = false;
        return;
      }
      if (!res.data) {
        this.loadingBin = false;
      }
      let arrData = res.data.map((item) => {
        return {
          value: (item.rate * 100).toFixed(2),
          name: item.cate,
        };
      });
      let myEchart = this.$echarts.init(document.getElementById("bin"));
      myEchart.setOption({
        series: [
          {
            type: "pie",
            roseType: "area",
            radius: [25, 125],
            itemStyle: {
              borderRadius: 0,
            },
            //  值
            data: arrData,
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  formatter: "{b}  {d}%", //带当前图例名 + 百分比
                },
                labelLine: { show: true },
              },
            },
          },
        ],
      });
      this.loadingBin = false;
    },
    async drawChartZhu() {
      this.loadingZhu = true;

      const [err, res] = await this.$http.post("study/courseTop");
      if (err) {
        this.loadingZhu = false;
        return;
      }
      let Ydata;
      let Xdata;
      let colorList;
      if (!res.data) {
        this.loadingZhu = false;

        Ydata = [];
        Xdata = [];
      } else {
        Ydata = res.data.map((item) => {
          return item.course_title;
        });
        Xdata = res.data.map((item) => {
          return item.course_pv;
        });

        colorList = res.data.map((item, index) => {
          if (res.data.length <= 3) {
            return "#2AB18B";
          } else {
            if (index >= res.data.length - 3) {
              return "#2AB18B";
            } else {
              return "#A8ABB2";
            }
          }
        });
      }
      let myEchart = this.$echarts.init(document.getElementById("zhu"));
      myEchart.setOption({
        color: colorList,
        inverse: true,
        grid: {
          left: "2%",
          right: "2%",
          bottom: "0%",
          top: "0%",
          containLabel: true,
        },
        yAxis: {
          data: Ydata,
          axisTick: {
            show: false, //刻度线
          },
          axisLine: {
            show: false, //隐藏y轴
          },
          axisLabel: {
            margin: 2,
            show: true,
            align: "right",
            formatter: function (params) {
              var maxLength = 10;
              //判断长度，超出使用...代替
              if (params && params.length > maxLength) {
                return params.substring(0, maxLength - 1) + "...";
              } else {
                return params;
              }
            },
          },
        },
        tooltip: {
          trigger: "item",
          formatter: function (params) {
            console.log(params);
            let tip = "";
            tip += `<div>${params.name}</div>`;
            return tip;
          },
        },
        xAxis: {
          show: false,
        },
        series: [
          {
            type: "bar",
            data: Xdata,
            barWidth: 16,

            label: {
              show: true,
              position: "right",
              color: "#000",
            },
            itemStyle: {
              normal: {
                color: function (params) {
                  return colorList[params.dataIndex];
                },
              },
            },
          },
        ],
      });
      myEchart.getZr().on("click", (params) => {
        let pointInPixel = [params.offsetX, params.offsetY];
        if (myEchart.containPixel("grid", pointInPixel)) {
          //点击第几个柱子
          let pointInGrid = myEchart.convertFromPixel(
            { seriesIndex: 0 },
            pointInPixel
          );
          // console.log(pointInGrid)
          // 也可以通过params.offsetY 来判断鼠标点击的位置是否是图表展示区里面的位置
          // 也可以通过name[xIndex] != undefined，name是x轴的坐标名称来判断是否还是点击的图表里面的内容
          // x轴数据的索引
          let xIndex = pointInGrid[0];
          // y轴数据的索引
          let yIndex = pointInGrid[1];
          // let routeData = this.$router.resolve({
          //   path: "/count_center/player",
          //   query: {
          //     id: res.data[yIndex].id,
          //     type: 2,
          //   },
          // });
          let routeData = this.$router.resolve({
            path: `/count_center/player/${res.data[yIndex].id}/2`,
          });
          window.open(routeData.href, "_blank");
        }
      });
      this.loadingZhu = false;
    },
    async getUserLog() {
      let { nowDate, page, page_size, user_id, totalPage } = this;
      const [err, res] = await this.$http.post("study/log", {
        month: nowDate,
        user_id,
        page,
        page_size,
      });
      if (err) {
        return;
      }
      if (!res.list) {
        this.page = 1;
        this.showTextFlag = true;
        return;
      }
      this.showTextFlag = false;
      this.totalPage = Math.ceil(res.total / page_size);
      this.study_time = moment.utc(res.study_time * 1000).format("HH:mm:ss");
      this.activities = res.list.map((item) => {
        return {
          course_id: item.course_id,
          study_time_long: moment
            .utc(item.study_time_long * 1000)
            .format("HH:mm:ss"),
          title: item.title,
          date:
            (item.date + "").slice(0, 4) +
            "-" +
            (item.date + "").slice(4, 6) +
            "-" +
            (item.date + "").slice(6, 8),
          course_cover_url: item.course_cover_url,
        };
      });
      if (res.page == 1) {
        this.nowDateList.push({
          title: moment(this.nowDate).format("YYYY 年MM月"),
          list: this.activities,
        });
      } else {
        this.nowDateList[this.nowDateList.length - 1].list.push(
          ...this.activities
        );
      }
      console.log(this.nowDateList);
    },
    getMon(date, num) {
      return moment(date).add(num, "month").format("YYYY-MM");
    },
    getVideoUrl(id) {
      let routeData = this.$router.resolve({
        path: `/count_center/player/${id}/1`,
      });
      window.open(routeData.href, "_blank");
      // this.$router.push(`/count_center/player/${id}/1`)
    },
    scrollbarDown() {
      this.$refs.scrollbar.handleScroll = () => {
        var wrap = this.$refs.scrollbar.wrap;
        this.$refs.scrollbar.moveY = (wrap.scrollTop * 100) / wrap.clientHeight;
        this.$refs.scrollbar.moveX = (wrap.scrollLeft * 100) / wrap.clientWidth;
        let poor = wrap.scrollHeight - wrap.clientHeight;
        if (
          poor == parseInt(wrap.scrollTop) ||
          poor == Math.ceil(wrap.scrollTop) ||
          poor == Math.floor(wrap.scrollTop)
        ) {
          if (this.page < this.totalPage) {
            this.page += 1;
            this.getUserLog();
          } else {
            this.showTextFlag = true;

            this.nowDate = this.getMon(this.nowDate, -1);
            this.page = 1;
            this.getUserLog();
          }
        }
      };
    },
    changeDate(val) {
      this.nowDate = moment(val).format("YYYY-MM");
      this.showDate = moment(val).format("YYYY-MM");
      this.page = 1;
      this.nowDateList = [];
      this.getUserLog();
    },
  },
};
</script>

<style lang="less" scoped>
.sidebar-wrapper {
  overflow-x: hidden !important;
}

/deep/.el-scrollbar__wrap {
  overflow-x: hidden !important;
  scrollbar-width: none; // 兼容火狐
}
/deep/.el-scrollbar__wrap::-webkit-scrollbar {
  width: 0 !important;
}
/deep/.el-timeline {
  padding: 15px;
}

.is-horizontal {
  display: none;
}

.study_info {
  margin-top: 16px;
  display: flex;
  justify-content: center;

  .study_info_log {
    width: 740px;
    height: 908px;
    // background: #ffffff;
    border-radius: 8px 8px 8px 8px;
    overflow-x: hidden;
    overflow-y: hidden;
    .left-box {
      background: #fff;
      padding: 24px;
    }
    .title_box {
      display: flex;
      justify-content: space-between;
      background: #fff;
      padding: 18px 24px;
      margin-bottom: 16px;
    }

    .title {
      font-size: 16px;
      font-weight: 600;
      color: #23262f;
    }

    .study_time {
      color: #606266;
    }

    .study_time_long {
      font-size: 13px;
      color: #2ab18b;
    }

    .study_title {
      color: #606266;
      font-size: 15px;
      font-weight: bold;
      padding-bottom: 10px;
    }

    .study_img {
      padding: 12px 0;

      img {
        width: 224px;
        height: 109px;
      }
    }
  }

  .study_info_echeart {
    padding-left: 16px;

    .study_info_host {
      width: 932px;
      height: 457px;
      background: #ffffff;
      border-radius: 8px 8px 8px 8px;

      .title {
        font-size: 16px;
        font-weight: 600;
        color: #23262f;
        padding: 24px 24px 0 24px;
      }

      .echarts_cotent {
        width: 672px;
        height: 400px;
      }
    }

    .study_info_top {
      margin-top: 16px;
      width: 932px;
      height: 435px;
      background: #ffffff;
      border-radius: 8px 8px 8px 8px;

      .title {
        font-size: 16px;
        font-weight: 600;
        color: #23262f;
        padding: 24px 24px 0 24px;
      }

      .echarts_cotent_zhu {
        background: #ffffff;
        width: 932px;
        height: 380px;
        box-sizing: border-box;
      }
    }
  }
}

.study_time_all {
  color: #2ab18b;
  font-size: 16px;
}

:deep(.el-scrollbar__view) {
  position: relative;
}

.date-picker {
  position: absolute;
  top: 0;
  right: 12px;
}
</style>